export default __webpack_public_path__ + "static/media/brew_with_the_crew_tile_cover.f269627a.png";